<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [dismissableMask]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  position="center"
  [appendTo]="'body'"
  [style]="{ width: '440px', 'max-width': '95vw' }"
  [contentStyle]="{ 'overflow-y': 'auto', 'max-height': '85vh', padding: '0' }"
  styleClass="cardapio-aviso-dialog cardapio-info-dialog"
  maskStyleClass="cardapio-info-mask"
  (onHide)="onHide()">

  <ng-template pTemplate="header">
    <div class="dialog-header-custom">
      <i [class]="icone + ' dialog-header-icon'"></i>
      <span class="dialog-header-title">{{ titulo }}</span>
    </div>
  </ng-template>

  <div class="aviso-content">
    <p class="aviso-texto">{{ mensagem }}</p>

    <button type="button" class="aviso-botao" (click)="fechar()">
      {{ textoBotao }}
    </button>
  </div>
</p-dialog>
